export const features = {
    "template": "template1",
    "companyName": "Rockford Mutual Insurance Company (RMIC)",
    "inowEndpoint": "https://rmic.iscs.com",
    "tokenIssuer": "https://rmic-inow.okta.com/oauth2/default",
    "clientId": "0oa232w66p8mm7SmA1d8",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "affiliatedCarrierAccess": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "cancelFutureScheduledPayments": false,
        "changeCoverage": false,
        "claimDetailsDocuments": false,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": true,
        "companyDocuments": false,
        "coverageDetails": false,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "customerInformation": true,
        "deactivateUserOnly": true,
        "defaultLossDateTime": false,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2080-01-01",
        "mfaEnabled": true,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": false,
        "payPlanTypesToFilter": [
            "Direct",
            "Automated",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [],
        "policyDocumentUpload": true,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": true,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": false,
        "scheduledPayments": false,
        "sendActivationEmail": false,
        "showCustomerDeliveryPreferences": true,
        "showImageTag": true,
        "showInstallPWA": false,
        "showPasswordToggle": false,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": false,
        "underlyingPoliciesPayPlansEditable": false,
        "useGooglePlacesInReportClaimFlow": true,
        "useInsuredAttachments": true,
        "verifyAddress": true,
        "verifyFlow": true,
        "viewChangeRequests": false
    },
    "keys": {
        "googleAnalytics": "UA-86277848-3",
        "googleAnalytics4": null,
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": ""
    },
    "salesPortalUrl": "",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "",
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js",
    "paymentTenantName": "tenant.rmic",
    "paymentConfigIds": {
        "RMIC": "28571901"
    },
    "paymentMethods": [
        "ACH",
        "CC"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC"
    ],
    "achEntryClassCode": "WEB",
    "processingFee": 0,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "60",
    "policiesCountLimit": "60",
    "billingAccountsCountLimit": "60",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 10,
            "message": "Use at least 10 characters"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "_meta": {
        "build": "4.0.0-25-ea44f5e",
        "commit": "ea44f5ec100eace5cbc9e6764247896eacb58a7f",
        "company": "rmic",
        "date": "2026-09-17T20:14:57+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": "25"
    }
};